<template>
    <span/>
</template>

<script>
const { mapState } = require("vuex");
const { SvgConstants } = require("../../config/config");
// other constants
const isEdge = /Edge/.test(navigator.userAgent);
const isIE = !!document.documentMode;

export default {
    name: "transcript-text-layer",
    props: ["svgNode", "transcriptHook", "textSvg"],

    computed: {
        ...mapState("transcript", ["eventBus", "opacity", ])
    },

    mounted() {
        this.eventBus.$on('svg-change', (svg) => {
            if (this.transcriptHook() && svg && svg.documentElement) {
                initTranscriptText(this.transcriptHook(), svg)
                adjustText(this.transcriptHook())
                setOpacity(this.transcriptHook(), this.opacity)
                this.eventBus.$emit('text-adjust', {})
            }
        })

        this.eventBus.$on('overlay-opacity-change', () => {
            if (this.transcriptHook) {
                setOpacity(this.transcriptHook(), this.opacity)
            }
        })
    }
}

function initTranscriptText(transcript, svg) {
    console.log("initializing text")
    svg = svg.documentElement;
    Array.from(svg.childNodes).forEach(node => {
        transcript.appendChild(
            document.importNode(node, true)
        )}
    );
}

function setOpacity(transcript, opacity) {
    if (!transcript) {
        return;
    }
    transcript.style.fillOpacity = opacity / 100;
}

function adjustText(svg) {
    console.log("adjusting text")
    Array.from(svg.querySelectorAll("text")).map(node => {
        const tp = node.querySelector("textPath");
        if(tp) {
            const linePath = document.getElementById(
                tp.getAttributeNS("http://www.w3.org/1999/xlink", "href")
                    .replace(/^#/, "")
                    .replace(/tp/, "lp"));
            const linePathLength =
                    linePath.getTotalLength();

            // render the text somewhere outside the line path and scale it it to the line path's length
            const plainText = node.textContent;

            const somewhereElse = document.createElementNS(SvgConstants.NS, "text");
            somewhereElse.setAttribute("x", 0);
            somewhereElse.setAttribute("y", 200);
            somewhereElse.textContent = plainText;
            somewhereElse.classList.add("line")
            somewhereElse.style.fontSize = SvgConstants.BASE_FONT_SIZE + "px";
            somewhereElse.style.visibility = "hidden";
            node.nearestViewportElement.append(somewhereElse);
            const detachedTextLength = somewhereElse.getComputedTextLength();

            somewhereElse.remove();

            const ieFactor = (isIE || isEdge) ? 1.15 : 1;
            const scalingFactor = linePathLength / (detachedTextLength * ieFactor);
            node.style.fontSize = (
                (SvgConstants.BASE_FONT_SIZE * scalingFactor) < SvgConstants.MAX_FONT_SIZE
                ? (SvgConstants.BASE_FONT_SIZE * scalingFactor)
                : SvgConstants.MAX_FONT_SIZE)
                + "px";

            // ensure optimal length in browsers that support the svg textLength attribute
            if(!isIE && !isEdge) {
                const textPathElement = node.getElementsByTagName("textPath").item(0);
                textPathElement.setAttribute("textLength", linePathLength);
                textPathElement.setAttribute("lengthAdjust", "spacingAndGlyphs");
                // for Firefox
                node.setAttribute("textLength", linePathLength);
                node.setAttribute("lengthAdjust", "spacingAndGlyphs");
            }
        }
    });
}
</script>